<ng-content *transloco="let t">
  <div class="app_notification_wrapper">
    @for(toast of toasts(); track toast.id) {
      <mc-toast
        [appearance]="toast.appearance || 'success'"
        (close)="clearToast(toast.id!)"
        [open]="toast.body !== '' || toast.heading !== ''"
        [position]="toast.position"
        [zindex]="99999"
        fit="medium"
        [duration]="toast.duration"
      >
        <mc-notification
          [icon]="toast.icon"
          [heading]="t(toast.heading || '')"
          [body]="t(toast.body)"
          [closable]="false"
        ></mc-notification>
      </mc-toast>
    }
  </div>
</ng-content>